import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { useRouter } from "../routing/hooks/useRouter.js";
import { useBlockAppender, useBlockContext, useValueStore } from "./inline-editing.js";
import { resolveAcfBlockName } from "./editor/block-templates.js";
export function EditableText({ id, as, appendOnEnter, removeOnDelete, plainText, store, ...props }) {
    if (env.admin) {
        const readOnly = useBlockContext()?.readonly;
        if (!readOnly) {
            const ref = useRef(null);
            const [value, setValue] = useValueStore(store ?? id);
            // useEffect(() => {
            //   if ((plainText || props.allowedFormats?.length === 0) && ref.current && !!value) {
            //     const placeholder = ref.current.querySelector("[data-rich-text-placeholder]")
            //     if (placeholder) return
            //     let wasUpdated = false
            //     ref.current?.childNodes.forEach((node) => {
            //       if (node.nodeType === Node.ELEMENT_NODE) {
            //         const element = node as Element
            //         if (element.tagName != "BR") {
            //           element.replaceWith(document.createTextNode(element.textContent ?? ""))
            //           wasUpdated = true
            //         }
            //       }
            //     })
            //     if (wasUpdated) {
            //       setValue(ref.current?.innerHTML)
            //     }
            //   }
            // }, [value, plainText, props.allowedFormats])
            const appendBlocks = useBlockAppender();
            return (_jsx(wp.blockEditor.RichText, { ...props, ref: ref, placeholder: props.defaultValue || props.placeholder, tagName: as, value: value || "", onChange: setValue, allowedFormats: props.inlineToolbar === false || plainText ? [] : props.allowedFormats, disableLineBreaks: props.disableLineBreaks, "data-allowed-formats": props.allowedFormats?.join(" "), onRemove: (forward) => {
                    if (removeOnDelete && !forward) {
                        const block = wp.data.select("core/block-editor").getSelectedBlock()?.clientId;
                        wp.data.dispatch("core/block-editor").removeBlock(block);
                    }
                }, onKeyDownCapture: (e) => {
                    if (e.key === "Enter" && appendOnEnter && appendBlocks && !e.shiftKey) {
                        appendBlocks([
                            wp.blocks.createBlock(typeof appendOnEnter === "string" ? resolveAcfBlockName(appendOnEnter) : "core/paragraph"),
                        ]);
                        e.preventDefault();
                        e.stopPropagation();
                    }
                } }));
        }
    }
    let [value] = useValueStore(store ?? id);
    const handleClickEvent = useRouter((r) => r.handleClickEvent);
    const otherProps = { ...props };
    delete otherProps.disableLineBreaks;
    delete otherProps.id;
    otherProps.as = otherProps.asProp ?? undefined;
    delete otherProps.asProp;
    delete otherProps.allowedFormats;
    delete otherProps.inlineToolbar;
    delete otherProps.disableLineBreaks;
    delete otherProps.placeholder;
    if (value === "" || typeof value !== "string") {
        if (props.defaultValue) {
            value = props.defaultValue;
        }
        else {
            return null;
        }
    }
    const Element = as || "div";
    return (_jsx(Element, { dangerouslySetInnerHTML: { __html: value }, 
        /**
         * Allow the router to handle link clicks, passing all clicks to the router.
         * We allow onClick on the current element to occur first, so that preventDefault can be called.
         * The router will filter out clicks where appropriate.
         */
        onClick: (e) => {
            if (props.onClick)
                props.onClick(e);
            handleClickEvent?.(e);
        }, ...otherProps }));
}
